module.exports = __webpack_public_path__ + "img/T931.df0358a9.jpg";